import { Injectable, Inject, Renderer2, RendererFactory2, PLATFORM_ID } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LoginTransversalService {

  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.generateScriptLoginTranversal(environment.scriptLoginTranversal);
   }

   generateScriptLoginTranversal(urlScript: string): void {

    if (isPlatformBrowser(this.platformId)) {
      let script = this.renderer.createElement('script');
      script.setAttribute('async', 'async');
      script.src = urlScript;
      this.renderer.appendChild(this.document.body, script);

    }
  }
}
